/** A quiet wait. Never a percentage, because nothing here knows one. */
export default function Spinner({ full = false, label }: { full?: boolean; label?: string }) {
  const dot = (
    <span className="relative flex h-2.5 w-2.5" aria-hidden>
      <span className="absolute inset-0 animate-pulseDot rounded-full bg-accent/70" />
    </span>
  );

  if (!full) {
    return (
      <span className="inline-flex items-center gap-2 text-sm text-ink/45">
        {dot}
        {label ?? 'Loading'}
      </span>
    );
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-paper"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 text-sm text-ink/45">
        {dot}
        {label ?? 'Loading'}
      </div>
    </div>
  );
}
